































import AutocompleteGeneric from '@/components/inputs/AutocompleteGeneric.vue'
import AutocompleteLocation from '@/components/inputs/AutocompleteLocation.vue'
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {WidgetFilterOptions} from '@/components/widgets/WidgetFather'
import {getAutocompleteFn} from '@/data/sources/autocomplete'

@Component({components: {AutocompleteGeneric, AutocompleteLocation}})
export default class InputString extends Vue {
  @Prop() public opts!: WidgetFilterOptions
  @Prop() public value!: string
  public autocompleteType: string = 'AutocompleteGeneric'
  public inputId = 'input-' + String(Math.floor((Math.random() * 100000)))
  public showAutocomplete = true
  public acValue: string = ""
  public focused: boolean = false
  public title: string = ''
  private autocompleteFunction: any = null

  @Watch('value')
  onValueChange(val: string) {
    this.acValue = String(val)
  }

  @Watch('acValue')
  onAcValueChange(val: string) {
    this.title = ''
    this.$emit('input', val)
  }

  @Watch('focused', {immediate: true})
  onFocusedChange(val: string) {
    !this.focused && setTimeout(() => this.autocompleteFunction && this.autocompleteFunction(this.value), 300)
  }

  get extendedValue() {
    return this.title ? `${this.title} (${this.value})` : this.value
  }


  public hideAutocomplete() {
    setTimeout(() => this.showAutocomplete = false, 300)
    this.focused = false
  }

  public created() {
    this.autocompleteType = this.opts.autocompleteType || this.autocompleteType
    if (this.autocompleteType === 'AutocompleteGeneric') {
      this.autocompleteFunction = async (id: string) => {
        const af = getAutocompleteFn(this.opts.autocompleteFn || '')
        const r = await af(id, true)
        if (r && r.length === 1) {
          this.title = r[0]['title']
        }
      }
    } else if (this.autocompleteType === 'AutocompleteLocation') {
      this.autocompleteFunction = async (loc: string) => {
        const af = getAutocompleteFn(this.opts.autocompleteFn || '')
        const r = await af(loc, true)
        const lTypes: { [key: string]: string } =
          {o: '', g: 'Region:', s: 'Site:', b: 'Building:', f: 'Floor', r: 'Room:'}
        if (r && r.length === 1) {
          this.title = `${lTypes[r[0]['type']]} ${r[0]['name']}`
        }
      }
    }
    this.value && this.autocompleteFunction && this.autocompleteFunction(this.value)
  }

}
